<template>
  <div class="">
    <div class="content" v-loading="loading">
      <div class="classbox">
        <div class="headbox" style="min-width: 100px">分类名称</div>
        <div class="d-f">
          <div class="imgsbox"> </div>
          <div class="timebox">创建时间</div>
          <div class="operate">操作</div>
        </div>
      </div>
      <div v-for="(item, index) of list" :key="index">
        <!-- 一级分类 -->
        <div class="classbox x-bc flex_star">
          <div class="d-f">
            <div class="headbox">
              <div
                class="icon-box"
                @click="openchild(item, index)"
                v-if="
                  item.children && item.children.length > 0 && setting_level > 1
                "
              >
                <i
                  class="el-icon-caret-bottom"
                  v-if="openindex.indexOf(item.store_category_id) != -1"
                ></i>
                <i class="el-icon-caret-right" v-else></i>
              </div>
              <div class="levels">一级</div>
              {{ item.store_category_name }}
            </div>
          </div>
          <div class="d-f">
            <div class="imgsbox">
              <div
                class="imgborder"
                v-if="item.image"
                @click="addimg(1, index)"
              >
                <div class="meng"><i class="el-icon-plus"></i></div>
                <el-image
                  class="img"
                  :src="item.image.url"
                  fit="cover"
                ></el-image>
              </div>
              <div v-else> </div>
            </div>
            <div class="timebox">{{ item.created_at || "-" }}</div>
            <div
              class="operate operate_btn"
              :class="
                item.store_category_id == cateValue.store_category_id
                  ? 'operate_btn_active'
                  : ''
              "
              style="cursor: pointer"
              @click="chooseItem(item)"
            >
              选择
            </div>
          </div>
        </div>
        <!-- 二级分类 -->
        <template v-if="setting_level > 1">
          <div
            v-for="(children, i) in item.children"
            :key="i"
            v-show="openindex.indexOf(item.store_category_id) != -1"
          >
            <div class="classbox childbox x-bc">
              <div class="d-f">
                <div class="headbox" style="padding-left: 20px">
                  <div
                    class="icon-box"
                    @click="openchildx(children, i)"
                    v-if="
                      children.children &&
                      children.children.length > 0 &&
                      setting_level > 2
                    "
                  >
                    <i
                      class="el-icon-caret-bottom"
                      v-if="openindes.indexOf(children.store_category_id) != -1"
                    ></i>
                    <i class="el-icon-caret-right" v-else></i>
                  </div>

                  <div class="icon-box">
                    <div class="codeimgs"></div>
                  </div>

                  <div class="levels">二级</div>
                  {{ children.store_category_name }}
                </div>
              </div>
              <div class="d-f">
                <div class="imgsbox">
                  <div
                    class="imgborder"
                    v-if="children.image"
                    @click="addimg(2, index, i)"
                  >
                    <div class="meng"><i class="el-icon-plus"></i></div>
                    <el-image
                      class="img"
                      :src="children.image.url"
                      fit="cover"
                    ></el-image>
                  </div>
                  <div v-else></div>
                </div>

                <div class="timebox">{{ children.created_at || "-" }}</div>
                <div
                  class="operate operate_btn"
                  :class="
                    children.store_category_id == cateValue.store_category_id
                      ? 'operate_btn_active'
                      : ''
                  "
                  style="cursor: pointer"
                  @click="chooseItem(children)"
                >
                  选择
                </div>
              </div>
            </div>
            <template v-if="setting_level > 2">
              <div
                class="classbox childbox"
                v-for="(tab, x) in children.children"
                :key="x"
                v-show="openindes.indexOf(children.store_category_id) != -1"
              >
                <div class="headbox" style="padding-left: 80px">
                  <div class="icon-box">
                    <div class="codeimgs"></div>
                  </div>
                  <div class="levels">三级</div>
                  {{ tab.name }}
                </div>
                <div class="d-f">
                  <div class="imgsbox">
                    <div
                      class="imgborder"
                      v-if="tab.image"
                      @click="addimg(3, index, i, x)"
                    >
                      <div class="meng"><i class="el-icon-plus"></i></div>
                      <el-image
                        class="img"
                        :src="tab.image.url"
                        fit="cover"
                      ></el-image>
                    </div>
                    <div v-else>-</div>
                  </div>

                  <div class="timebox">{{ tab.created_at || "-" }}</div>
                  <div
                    class="operate operate_btn"
                    :class="
                      tab.store_category_id == cateValue.store_category_id
                        ? 'operate_btn_active'
                        : ''
                    "
                    style="cursor: pointer"
                    @click="chooseItem(tab)"
                  >
                    选择
                  </div>
                </div>
              </div>
            </template>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { eltips } from "@/util/util.js";
import draggable from "vuedraggable";
import { resolveWeiShopApi } from "@/views/apps/weishop/region/utils/regionApiMap";
export default {
  name: "classifylist",
  components: {
    draggable,
  },
  data() {
    return {
      loading: false,
      list: [],
      openindex: [],
      openindes: [],
      imgplugin: false,
      img_level: "",
      one_index: "",
      two_index: "",
      three_index: "",
      adv_info: {
        id: "",
        ad_image: "",
        goods_id: 1,
        goods_name: "",
      },
      adv_index: "",
      setting_level: 3,
      newSort: 0,
      keyword: "",
      goodsloading: false,
      goodslist: [],
      goodspage: 1,
      goodstotal: 0,
      cateValue: {},
    };
  },
  created() {
    this.getList();
  },
  methods: {
    openAdvimg() {
      this.img_level = "";
      this.imgplugin = true;
    },
    chooseItem(e) {
      console.log("我是当前选择", e);
      this.cateValue = e;
      this.$emit("getItem", e);
    },
    //获取列表
    getList() {
      this.loading = true;
      let data = {
        keyword: "",
        page: 1,
        limit: 10,
      };
      this.axios.get(resolveWeiShopApi("/api/shop/basic/store-category"), data).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.list = res.data || [];
          this.newSort = this.list.length;
        } else {
          eltips(res.msg, "error");
        }
      });
    },

    //打开折叠
    openall() {
      if (
        this.openindex.length == this.list.length &&
        this.openindex.length != 0
      ) {
        this.openindex = [];
        this.openindes = [];
      } else {
        let arr = [];
        let arr2 = [];
        this.list.forEach((item) => {
          arr.push(item.store_category_id);
          item.children.forEach((item2) => {
            arr2.push(item2.store_category_id);
          });
        });
        this.openindex = arr;
        this.openindes = arr2;
      }
    },
    openchild(item) {
      if (this.openindex.indexOf(item.store_category_id) == -1) {
        this.openindex.push(item.store_category_id);
      } else {
        this.openindex.splice(this.openindex.indexOf(item.store_category_id), 1);
      }
    },
    openchildx(item) {
      if (this.openindes.indexOf(item.store_category_id) == -1) {
        this.openindes.push(item.store_category_id);
      } else {
        this.openindes.splice(this.openindes.indexOf(item.store_category_id), 1);
      }
    },
  },
};
</script>

<style scoped lang="less">
.x-bc {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.flex_star {
  display: flex;
  justify-content: flex-start;
}
.d-f {
  display: flex;
  justify-content: center;
  align-content: center;
}
.btn {
}
#classifylist {
  /* min-height: calc(100vh);
        padding-bottom: 20px; */
}

.titlebox {
  margin-bottom: 10px;
  background: #ffffff;
  padding: 10px;
}

.content {
  padding: 10px;
  overflow: auto;
  //   height: calc(100vh - 190px);
  background: #ffffff;
}

.classbox {
  width: 100%;
  background: #f4f6f8;
  border: 1px solid #e9edef;
  border-radius: 2px;
  height: 70px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: flex-start;
  box-sizing: border-box;
  position: relative;

  .draggable-icon {
    padding: 0 10px;
  }

  .headbox {
    display: flex;
    padding: 0 10px;
    min-width: 150px;
    // flex: 1;
    width: 238px;
    justify-content: left;
    align-items: center;

    .icon-box {
      margin-right: 15px;
      font-size: 22px;
      color: #999;
      cursor: pointer;
      padding: 0 6px;

      &:hover {
        color: #1e92ff;
      }

      .codeimgs {
        width: 14px;
        height: 14px;
        border-left: 1px solid #999;
        border-bottom: 1px solid #999;
        position: relative;
        top: -4px;
      }
    }

    .levels {
      margin-right: 10px;
    }

    .inputbox {
      margin-right: 10px;
    }

    .addbtn {
      color: #1e92ff;
      font-size: 14px;
      cursor: pointer;
    }
  }

  .imgsbox {
    min-width: 260px;
    display: ruby;
    .imgborder {
      width: 60px;
      height: 60px;
      position: relative;

      &:hover {
        .meng {
          opacity: 1;
        }
      }

      .img {
        width: 100%;
        height: 100%;
      }

      .meng {
        cursor: pointer;
        z-index: 1;
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 28px;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        color: #ffffff;
      }
    }

    .addbox {
      border: 1px dashed #e9edef;
      width: 60px;
      height: 60px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      background: #fff;

      .addicon {
        font-size: 28px;
        color: #006aff;
      }

      .text {
        font-size: 12px;
        color: #999;
        line-height: 12px;
      }
    }
  }

  .timebox {
    min-width: 204px;
    flex: 1;
  }

  .statusbox {
    min-width: 100px;
    flex: 1;
  }

  .operate {
    flex: 1;
    min-width: 80px;
  }
  .operate_btn {
    border: 1px solid #d8d8d8;
    border-radius: 4px;
    height: 30px;
    line-height: 30px;
    &:hover {
      color: #fff;
      background: #006aff;
      border: 1px solid #006aff;
    }
  }
  .operate_btn_active {
    color: #fff;
    background: #006aff;
    border: 1px solid #006aff;
  }
}

.childbox {
  margin-top: 0;
  border-top: none;
}

.advbox {
  .addbox {
    width: 80px;
    height: 80px;
    background: #f4f6f8;
    border: 1px solid #e9edef;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
  }

  .imagebox {
    background: #f4f6f8;
    border: 1px solid #e9edef;
    width: 310px;
    height: 120px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;

    .icon {
      font-size: 32px;
      color: #1e92ff;
    }

    .text {
      color: #b8b9bd;
      margin-top: 10px;
      font-size: 14px;
      line-height: 12px;
    }

    .img {
      display: block;
      width: 310px;
      height: 120px;
    }

    .meng {
      width: 100%;
      text-align: center;
      line-height: 40px;
      background: rgba(0, 0, 0, 0.6);
      color: #ffffff;
      position: absolute;
      left: 0;
      bottom: 0;
    }

    .delicon {
      font-size: 20px;
      position: absolute;
      right: -10px;
      top: -10px;
    }
  }
}

.dialogtabel {
  .icon {
    display: inline-block;
    vertical-align: middle;
    font-size: 12px;
    width: 20px;
    line-height: 20px;
    text-align: center;
    margin-right: 6px;
  }

  .name {
    width: 394px;
    vertical-align: top;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .choosebtn {
    width: 60px;
    line-height: 32px;
    border-radius: 2px;
    color: #006aff;
    border: 1px solid #c3c3c3;
    cursor: pointer;

    &:hover {
      border-color: #006aff;
    }
  }

  .choose {
    background: #006aff;
    color: #ffffff;
    border-color: #006aff;
  }
}

.tips {
  color: #ff1f2c;
  font-weight: bold;
  font-size: 12px;
  line-height: 17px;
  margin-top: 10px;
}

.button_down {
  bottom: 0px;
}
</style>
